import { useEffect,useRef } from 'react'

/**
 * Simple hook for attaching event listeners to a given element, defaults to the window
 * Handles it's own internal reference instead of getting it passed in
 * @param eventName - name of the event on the element to listen for
 * @param handler - event handler function to execute when the event is triggered
 * @param element - element to put the listener on, defaults to the window
 */
const useEventListener = (eventName: string, handler: Function = () => {}, element: HTMLElement | Window = window) => {
  const savedHandler = useRef<Function>()

  useEffect(() => {
    savedHandler.current = handler
  }, [handler])

  useEffect(
    () => {
      const isSupported = element && element.addEventListener
      if (!isSupported)  {
        return
      }

      const eventListener = (event) => savedHandler.current(event)
      element.addEventListener(eventName, eventListener)

      return () => {
        element.removeEventListener(eventName, eventListener)
      }
    },
    [eventName, element]
  )
}

export default useEventListener
